<template>
    <div class="flight-stop d-flex my-4">
        <font-awesome-icon
            :icon="['fal', 'location-dot']"
            fixed-width
            class="flight-line-icon text-dark trip-line-pin me-2"
        />
        <div class="flex-grow-1">
            <div class="lead mb-2">
                <strong class="me-2">{{$filters.beautifyTime(stop.stopDateTime)}}</strong> {{stopAirport.city}} ({{stopAirport.iata}})
            </div>
            <!--TODO tweak verbiage based on whether or not there is a change of gauge (different plane?) -->
            <small>{{$t('common.itinerary.layover', {time: stop.groundTime})}} &bull; {{$t('common.itinerary.changeOfPlane')}}</small>
        </div>
    </div>
    <div class="flight-stop-time d-flex align-items-center my-4">
        <font-awesome-icon
            :icon="['fal', 'plane']"
            fixed-width
            rotation="90"
            class="flight-line-icon text-dark trip-line-pin me-2"
        />
        <div>{{$t('common.itinerary.flightTime', {time: stop.flightDuration})}}</div>
    </div>
</template>

<script>
export default {
    name: 'FlightStop',
    props: {
        stop: {
            type: Object,
            required: true
        },
        trip: {
            type: Object,
            required: true
        }
    },
    computed: {
        stopAirport() {
            return Object.values(this.trip.pnr.airports).find(airport => airport.iata === this.stop.stopAirportCode);
        }
    }
};
</script>

<style lang="scss" scoped>
.flight {
    .airline-logo {
        height: 1.75rem;
    }
    .flight-line {
        padding-left: 1.0rem;
        margin-left: 1.0rem;
        border-left: 1px solid $dark;
        > div {
            line-height: 1.0;
            margin-left: -2.0rem;
        }
        .flight-line-icon {
            font-size: 1.55rem;
            background: white;
        }
    }
}
</style>